import React from 'react';
import MobileDevPageStage320x100Fs from './freestar/MobileDevPageStage320x100';
const MobileDevPageStage320x100 = ({ safety = 'off', safetyState })=>/*#__PURE__*/ React.createElement(MobileDevPageStage320x100Fs, {
        safety: safety,
        safetyState: safetyState
    });
MobileDevPageStage320x100.displayName = 'MobileDevPageStage320x100';
export default MobileDevPageStage320x100;
